<template>
    <!-- Modal -->
    <div class="modal fade" id="add_new_address" role="dialog" aria-labelledby="myModalLabel" style="z-index:3000 !important">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel2">Add / Update Address Of Customer: {{c_name}}</h4>
                </div>
                <form id="addressForm" method="post" @submit.prevent="updateAddress()">
                <div class="modal-body">
                    <CitiesAndAreas ref="cityAndAreaComp" :isAddingNewCustomer="true" />
                    <div class="form-group">
                        <label >Address</label>
                        <textarea rows="5" class="form-control" placeholder="Address..." v-model="address.address" required="required"></textarea>
                    </div>
                  <div class="form-group">
                    <label >Title</label>
                    <input type="text" class="form-control" placeholder="Add address title like home, office..." v-model="address.title">
                  </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    <button type="submit" v-bind:disabled="disabled" class="btn btn-primary">Save</button>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import CitiesAndAreas from "@/components/utils/CitiesAndAreas"
    export default {
        name: "AddNewBebambiCustomerAddress",
        components: {
            CitiesAndAreas
        },
        data() {
            return {
                disabled: false,
                c_id: "",
                c_name: "",
                address: {
                    "id": 0,
                    "address": "",
                    "title": "",
                    "deleted": false,
                    "dvmCustomer": {
                        "id": 0,
                    },
                  'citiesByCityId': {
                    'id': 1
                  },
                },
                userRole:''
            }
        },
        props: [
            "customerName",
            "customerId",
            "from"
        ],
        mounted: function(){
            let modalSelector = $('#add_new_address');
            modalSelector.on('hidden.bs.modal',  (e) => {
               this.resetData();
            });
            modalSelector.on('shown.bs.modal',  (e) => {
                if(this.customerName !== '' && this.customerId !== ''){
                    this.c_name = this.customerName;
                    this.c_id = this.customerId;
                }
            });
        },
        methods: {
            loadForNewInsertion: function () {
                $("#add_new_address").modal("show");
            },
            updateAddress: function () {
              console.log(this.$refs.cityAndAreaComp.selectedCity)
                this.disabled = true;
                this.address.area = this.$refs.cityAndAreaComp.area.name;
                this.address.latitude = this.$refs.cityAndAreaComp.area.lat;
                this.address.longitude = this.$refs.cityAndAreaComp.area.lng;
                this.address.citiesByCityId.id = this.$refs.cityAndAreaComp.selectedCity;
                this.address.dvmCustomer.id = this.c_id;
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                        this.$parent.isHideSpinner="";
                    },
                });
              console.log(this.address)
                this.$http.post(this.$store.state.mainAppURL + "customers/add_customer_dvm_address", this.address).then(resp => {
                    $("#add_new_address").modal("hide");
                    Swal.close();
                    if(this.from === "vcd"){
                        this.$parent.load(this.c_id, this.c_name, "active");
                    }
                    this.$parent.loadBaykedCustomerData()
                    this.resetData();
                });
            },
            resetData: function () {
                Object.assign(this.$data, this.$options.data.call(this));
                this.$refs.cityAndAreaComp.resetData();
            }
        }
    }
</script>

<style scoped>

</style>
